<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div
          class="banner-container"
          [ngClass]="{ 'banner-container-unit': isUnitPortalStyle && !applyBackgroundImage }"
          [ngStyle]="getBannerBackground()"
        >
          <div [ngClass]="isUnitPortalStyle ? 'banner-title-unit' : 'banner-title'">
            <ng-container *ngIf="!isUnitPortalStyle">
              <h4 color="inverse" weight="semibold">{{ home?.arte?.titulo || "Estamos trabajando en" }}</h4>
              <h1 uni-heading color="inverse" weight="semibold">{{ home?.arte?.descripcion || "Nuevas funcionalidades" }}</h1>
              <h2 uni-heading color="inverse" weight="semibold">
                {{ home?.arte?.descripcionCorta }}
              </h2>
              <a
                *ngIf="home?.manuales?.returnUrl"
                [routerLink]="[home?.manuales?.returnUrl]"
                class="mt-3"
                uni-button
                variant="info"
                icon="arrow-right"
                >Ir a la Sección</a
              >
            </ng-container>
            <ng-container *ngIf="isUnitPortalStyle">
              <h1 color="inverse" weight="semibold">Seguros fáciles de contratar</h1>
              <h1 color="inverse" weight="semibold">y rápidos para pagar.</h1>
              <h4 uni-heading color="inverse" weight="semibold">Descubre un mundo maravillosamente simple</h4>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="displayMetricsByPortal()">
      <div class="mt-5" *ngIf="isIntermedario || home.metricas">
        <div>
          <h3 uni-heading color="primary" alignText="center" weight="light">Reporte General</h3>
        </div>
      </div>

      <div *ngIf="totalAffiliate$ | async as totalAffiliate" class="pb-5">
        <div>
          <h2 uni-heading color="primary" alignText="center">Cantidad de Contratos/Pólizas</h2>
        </div>
        <div class="row mt-5 justify-content-center">
          <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-center position-relative">
            <img class="icon-portales" width="32" height="38" src="assets\images/cert-icon.svg" alt="icon salud local" />
            <h1 class="huge-letter text-primary">
              {{ totalAffiliate?.localHealthTotal }}
            </h1>
            <span class="comentario-metrica text-secondary">Salud Local</span>
          </div>

          <div class="col-sm-12 col-md-3 d-flex justify-content-center align-items-center position-relative mt-5 mt-md-0">
            <img class="icon-portales" width="32" height="38" src="assets\images/cert-icon.svg" alt="icon de riesgos generales" />
            <h1 class="huge-letter text-primary">
              {{ totalAffiliate?.insuranceTotal }}
            </h1>
            <span class="comentario-metrica text-secondary">Riesgos Generales y Personas</span>
          </div>
        </div>
      </div>

      <div class="my-5 pt-5" *ngIf="home.metricas">
        <div class="row">
          <div class="col-12 d-flex justify-content-center">
            <div>
              <h2 uni-heading color="primary" alignText="center">Resumen de Actividades</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-center justify-content-md-end align-items-center align-top-tittle">
            <div class="position-relative">
              <div (click)="toggleMenuView()">
                <span class="mr-2 text-right"><strong>Ver:</strong> {{ periodicidad?.title || "Este mes" }} </span>
                <img class="chev-icon" alt="chevron-down" width="14" src="assets/images/chevron-down.svg" />
              </div>
              <div (click)="toggleMenuView()" [class.visible-menu]="toggled" class="hover-menu-navigation">
                <ul>
                  <li (click)="selectPeriodicidad(option)" *ngFor="let option of _ultimosDiasMetricas">
                    {{ option.title }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2 justify-content-center">
          <div
            *ngFor="let metrica of home?.metricas"
            class="col-sm-12 col-md-3 d-flex justify-content-center align-items-center position-relative"
          >
            <img class="icon-portales" width="32" alt="{{ metrica.titulo }}" [src]="metrica.imagenUrl" />
            <h1 class="huge-letter text-primary">{{ metrica.valor }}</h1>
            <span class="comentario-metrica text-secondary">{{ metrica.titulo }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
